import { SaveStatusProvider } from '@/contexts/SaveStatusContext'
import { FormationEditorContent } from './FormationEditorContent'

export function FormationEditorPage() {
	return (
		<SaveStatusProvider>
			<FormationEditorContent />
		</SaveStatusProvider>
	)
}
